var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'spacebar'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "steps-container"
  }, [_c('figure', {
    staticClass: "step-image"
  }, [_vm.imagePath ? _c('img', {
    attrs: {
      "alt": "Main image",
      "src": _vm.imagePath
    }
  }) : _vm._e()]), _c('ul', {
    staticClass: "text-steps"
  }, _vm._l(_vm.currentRound.steps, function (step, stepIndex) {
    return _c('li', {
      key: ((_vm.progress.roundIndex) + "-" + stepIndex),
      class: ("list-step step-" + stepIndex)
    }, [step.isTyped ? _c('color-block-text', {
      class: _vm.getTextSize,
      attrs: {
        "text": step.answer,
        "text-step": stepIndex
      }
    }) : _c('p', {
      class: ("static-text " + (_vm.getTextSize))
    }, [_vm._v("\n              " + _vm._s(step.answer) + "\n            ")])], 1);
  }), 0)])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }